import {UiHomeNoticeModificationVerboseDomain} from "../../domain/ui/UiHomeNoticeModificationVerboseDomain"
import {UiHomeNoticeId} from "../../id/ui/UiHomeNoticeId"
import {UiHomeNoticeModificationId} from "../../id/ui/UiHomeNoticeModificationId"
import {UserId} from "../../id/user/UserId"
import {UserValueObject} from "../user/UserValueObject"
import {UiHomeNoticeValueObject} from "./UiHomeNoticeValueObject"
import {VerboseValueObject} from "ts-protocol-extension"

/**
 * 홈 공지 및 이벤트 수정 이력 상세
 */
export class UiHomeNoticeModificationVerboseValueObject implements VerboseValueObject, UiHomeNoticeModificationVerboseDomain {
    /**
     * 기본키
     */
    id: UiHomeNoticeModificationId
    /**
     * 수정자 ID
     */
    creatorId: UserId
    /**
     * 홈 공지 및 이벤트 ID
     */
    uiHomeNoticeId: UiHomeNoticeId
    /**
     * 표시 우선 순위
     */
    displayOrder: number
    /**
     * URL
     */
    url: string
    /**
     * 수정일
     */
    createdAt: Date
    /**
     * 수정자 ID
     */
    creator: UserValueObject
    /**
     * 홈 공지 및 이벤트 ID
     */
    uiHomeNotice: UiHomeNoticeValueObject

    constructor(o: Record<keyof UiHomeNoticeModificationVerboseDomain, any>) {
        this.id = BigInt(o.id)
        this.creatorId = BigInt(o.creatorId)
        this.uiHomeNoticeId = BigInt(o.uiHomeNoticeId)
        this.displayOrder = Number(o.displayOrder)
        this.url = String(o.url)
        this.createdAt = new Date(o.createdAt)
        this.creator = new UserValueObject(o.creator)
        this.uiHomeNotice = new UiHomeNoticeValueObject(o.uiHomeNotice)
    }
}
